module.exports = __webpack_public_path__ + "img/cloth_g1_shirt_15.62c5c058.svg";